import React, {useEffect} from "react";
import PropTypes from "prop-types";
import usePaySafeVm, {ViewMode} from "./PaySafe.vm";
import BillingInfoForm from "./components/BillingInfoForm/BillingInfoForm";
import AddFundsConfirmation from "../components/AddFundsConfirmation/AddFundsConfirmation";
import MiniSteps from "../../../../components/MiniSteps/MiniSteps";
import ProductSelection from "../components/ProductSelection/ProductSelection";
import {_t} from "../../../../utils/I18nUtils";
import "./PaySafe.style.scss"

const trKey = "views.addFundView";

const PaySafe = (props) => {
    const vm = usePaySafeVm(props);

    useEffect(() => {
        /*if (GlobalConst.FEATURES.ID_VALIDATION_BEFORE_ADDFUND) {
            if (vm.account.idStatus != "Verified") {
                vm.setIdVerificationPrompted(true);
                vm.setViewMode(ViewMode.ID_VALIDATION_REQUIRED);
                if (!IdValidationStore.isVerifyIdPopUpPrompted()) {
                    vm.openVerificationPopUp;
                }
            }
        }*/
    }, []);

    const renderEnterBillingInfoView = () => {

        return <div >
            <h2>{_t(`${trKey}.paymentMethod`)}</h2>
            <br/>
            {vm.billingError && <div className="validation-summary-errors"><span
                dangerouslySetInnerHTML={{__html: vm.billingError}}></span></div>}
            <BillingInfoForm vm={vm}
                             actionBtnSelector=".billingContinueBtn"
                             onFormValidChange={(isValid) => {
                                 vm.setIsBillingFormDataValid(isValid);
                             }}
            />
            <div className="buttonsBar">
                <a onClick={vm.onReturnToProdSelectionClick} className="btn btn-link btn-md"><i
                    className="fa fa-fw fa-arrow-left" key="returnPdSelection"/> {_t(`${trKey}.backBtn`)}</a>
                <a onClick={vm.onBillingContinueClick} className={"btn btn-primary btn-md billingContinueBtn "}
                   key="nextBtn">{_t(`${trKey}.continueBtn`)}</a>
            </div>
        </div>
    };

    const renderConfirmationView = () => {
        return <div>
            <h2>{_t(`${trKey}.confirmation`)}</h2>
            <AddFundsConfirmation vm={vm}
                                  product={vm.selectedProduct}
                                  onUserAgreed={vm.onUserAgreed}
                                  />

            <div className="buttonsBar">
                <a onClick={() => vm.setViewMode(ViewMode.ENTER_BILLING_INFO)} className="btn btn-link btn-md"><i
                    className="fa fa-fw fa-arrow-left" key="returnPdSelection"/> {_t(`${trKey}.backBtn`)}</a>
                <a onClick={vm.onProceedPurchaseClick}
                   className={"btn btn-primary btn-md purchaseBtn " + (vm.userAgreed ? "" : "disabled")}
                   key="nextBtn">{_t(`${trKey}.purchaseBtn`)}</a>
            </div>
        </div>
    }

    const renderOrderProcessing = () => {
        return <div className="orderProcessing text-center">
            <h2 className="text-center">{_t(`${trKey}.processingInProgress`)}</h2>
            <br/>
            <p className="text-center">{_t(`${trKey}.waitForProcess`)}</p>
            <div><i className="fa fa-fw fa-spinner fa-pulse fa-3x"/></div>
            <div className="secureDepositDetails"><span> {_t(`${trKey}.secureDepositDetails`)} </span></div>
        </div>;
    };

    const renderOrderConfirmed = () => {
        return <div className="orderConfirmed">
            <h2 className="text-center"><i className="fa fa-fw fa-check-circle"
                                           style={{color: '#00b86f'}}/> {_t(`${trKey}.fundsAdded`)}</h2>
            <br/>
            <div className="buttonsBar text-center">
                <a onClick={vm.handleOrderConfirmedOkClick} className="btn btn-primary btn-md">{_t(`${trKey}.closeBtn`)}</a>
            </div>
        </div>;
    };

    const renderOrderProcessingError = () => {
        return <div className="orderProcessingError">
            <h2><i className="fa fa-fw fa-times-circle" style={{color: '#f34343'}}/> {_t(`${trKey}.paymentFailed`)}</h2>
            <p>{_t(`${trKey}.paymentProcessErrorMsg`)}</p>
            {vm.errors?.length > 0 && <div className="validation-summary-errors">
                <ul>{vm.errors.map((e, i) => <li key={`error${i++}`}>{e}</li>)}</ul>
            </div>}
            <div className="buttonsBar text-center">
                <a onClick={vm.onReturnToProdSelectionClick}
                   className="btn btn-primary btn-md">{_t(`${trKey}.returnBtn`)}</a>
            </div>
            <div className="secureDepositDetails"><span> {_t(`${trKey}.secureDepositDetails`)} </span></div>
        </div>;
    };

    const renderIdValidationRequired = () => {
        // Select the element with the class 'AddFundsPopUp'
        let element = document.querySelector('.AddFundsPopUp');
        element.classList.add('orderError');

        return (
            <div className="orderProcessingError">
                <div className="row">
                    <div className="icon col-md-12 text-center">
                        <i className={"fa fa-fw fa-times-circle"}/>
                    </div>
                    <h2 className="text-center">{_t(`${trKey}.idVerificationRequired`)}</h2>
                    <div className="col-md-12">
                        <div id="msgPopUpContent">
                            <p>{_t(`${trKey}.requireIdentityVerificationMsg`)}</p>
                        </div>
                    </div>
                </div>
                <div id="msgPopUpButtonsBar" className="text-center">
                    <button className={`msgVerifyBtn green`}
                            onClick={() => {
                                vm.openVerificationPopUp();
                                element.classList.remove('orderError');
                            }}>
                        {_t(`${trKey}.verifyMyIdentity`)}
                    </button>
                    <button className={`msgCancelBtn gray`}
                            onClick={() => {
                                vm.onCloseBtnClick();
                                element.classList.remove('orderError');
                            }}>
                        {_t(`${trKey}.cancelBtn`)}
                    </button>
                </div>
                <div className="secureDepositDetails"><span> {_t(`${trKey}.secureDepositDetails`)} </span></div>
            </div>
        )
    };

    let steps = [ViewMode.PRODUCT_SELECTION,
                ViewMode.ENTER_BILLING_INFO,
                ViewMode.CONFIRMATION];

    return (
        <div className={"PaySafe AddFundsContent step_" + vm.viewMode + (vm.ccInfo.isCustom ? " custom" : "") + ""}>
            {{
                [ViewMode.PRODUCT_SELECTION]: () => <ProductSelection vm={vm} parlayContext={props.parlayContext}/>,
                [ViewMode.ENTER_BILLING_INFO]: renderEnterBillingInfoView,
                [ViewMode.CONFIRMATION]: renderConfirmationView,
                [ViewMode.ORDER_PROCESSING]: renderOrderProcessing,
                [ViewMode.ORDER_CONFIRMED]: renderOrderConfirmed,
                [ViewMode.ORDER_PROCESSING_ERROR]: renderOrderProcessingError,
                [ViewMode.ID_VALIDATION_REQUIRED]: renderIdValidationRequired,
            }[vm.viewMode]()}

            {steps.includes(vm.viewMode) &&
                <MiniSteps steps={steps}
                           currentStep={vm.viewMode}
                           onStepClick={v => {
                               vm.setViewMode(v);
                           }}
                />}
        </div>
    )
}

PaySafe.propTypes = {
    close: PropTypes.func,
    showCloseBtn: PropTypes.bool,
};

export default PaySafe;
